import {
  WINDOW
} from "../constants/environment"
import {
  GOOGLE_MAPS_API_KEY
} from "../constants/config"

export default class googleAutoComplete {
  constructor() {
    if (!WINDOW.google ||
      !WINDOW.google.maps ||
      !WINDOW.google.maps.places ||
      !WINDOW.google.maps.places.AutocompleteService) {
      this._init()
    } else {
      WINDOW.googleScript = true
    }
  }

  _init = () => {
    if (WINDOW && WINDOW.document && !WINDOW.googleScript) {
      WINDOW.googleScript = true
      let script = WINDOW.document.createElement("script")
      script.src = `https://maps.googleapis.com/maps/api/js?key=${GOOGLE_MAPS_API_KEY}&libraries=places`
      WINDOW.document.body.appendChild(script)
    } else {
      setTimeout(() => {
        this._init()
      }, 100)
    }
  }

  searchPostcode = (input = "", callback = () => {}) => {
    if (input === "" || !input) return;
    if (WINDOW && WINDOW.google && WINDOW.googleScript) {
      const service = new WINDOW.google.maps.places.AutocompleteService()
      console.log('places prediction')
      console.log(input)
      return service.getPlacePredictions({
        input: input,
        types: ["(regions)"],
        componentRestrictions: {
          country: "nz"
        }
      }, callback)
    } else {
      setTimeout(() => {
        this.searchPostcode(input, callback)
      }, 100)
    }
  }

  searchAddress = (input = "", callback = () => {}) => {
    if (WINDOW && WINDOW.google && WINDOW.googleScript) {
      const service = new WINDOW.google.maps.places.AutocompleteService()
      return service.getPlacePredictions({
        input: input,
        types: ["address"],
        componentRestrictions: {
          country: "nz"
        }
      }, callback)
    } else {
      setTimeout(() => {
        this.searchAddress(input, callback)
      }, 100)
    }
  }

  getPostcode = (address = "", callback = () => {}) => {
    if (WINDOW && WINDOW.google && WINDOW.googleScript) {


      const geocoder = new google.maps.Geocoder()
      return geocoder.geocode({
        "address": address
      }, callback)
    } else {
      setTimeout(() => {
        this.getPostcode(address, callback)
      }, 100)
    }
  }

  getPlaceUsingPlaceId = (placeId, callback = () => {}) => {
    console.log('placeId')

    if (WINDOW && WINDOW.google && WINDOW.googleScript) {
      const geocoder = new google.maps.Geocoder()
      return geocoder.geocode({
        "placeId": placeId
      }, callback)
    } else {
      setTimeout(() => {
        this.getPostcodeUsingLatLong(address, callback)
      }, 100)
    }
  }
}



// WEBPACK FOOTER //
// ./src/AtomicUtils/googleAutoComplete.js